<template>
  <div id="app">
    <b-modal
      id="mdlCaixaEntrada"
      ref="mdlCaixaEntrada"
      title="Escolher conta"
      ok-title="Salvar"
      ok-only
      @ok="salvarNumerosWhatsapp"
      size="lg"
    >
      <b-form
        v-if="selectedNumber"
        id="frmNumerosWhatsapp"
        ref="frmNumerosWhatsapp"
      >
        <b-row class="mb-1">
          <b-col cols="3">
            <b-form-input
              v-model="selectedNumber.phone_number"
              disabled
              v-blur-sensitive
            ></b-form-input>
          </b-col>
          <b-col cols="5">
            <b-form-group>
              <b-form-input
                v-model="selectedNumber.inbox_name"
                placeholder="Nome da caixa de entrada"
                :disabled="!criarCaixaEntrada"
                v-blur-sensitive
              ></b-form-input>
              <b-form-checkbox
                v-model="criarCaixaEntrada"
                switch
                size="md"
                class="mb-2 mt-2"
              >
                Criar caixa de entrada
              </b-form-checkbox>
              <span>
                Desmarque essa opção apenas se já existir uma caixa de entrada
                para este número.
              </span>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-select
              v-model="selectedNumber.conta_id"
              :options="contasDisponiveis"
            ></b-form-select>
          </b-col>
        </b-row>
      </b-form>
    </b-modal>
    <b-modal
      id="mdlExcluirNumero"
      ref="mdlExcluirNumero"
      title="Escolha o que deseja fazer"
      ok-title="Confirmar"
      :ok-disabled="
        !deleteNumberOptions.excluirCaixaEntrada &&
        !deleteNumberOptions.desvincularNumero
      "
      @ok="deleteNumber(selectedNumber, selectedWaba)"
      cancel-title="Cancelar"
      :centered="true"
    >
      <b-form id="frmDeleteNumber" ref="frmDeleteNumber">
        <b-row class="mb-1">
          <b-col>
            <b-form-checkbox
              v-model="deleteNumberOptions.excluirCaixaEntrada"
              style="margin-bottom: 10px"
              size="lg"
            >
              Excluir caixa de entrada
            </b-form-checkbox>
            <b-form-checkbox
              v-model="deleteNumberOptions.desvincularNumero"
              size="lg"
            >
              Desvincular número da conta
            </b-form-checkbox>
          </b-col>
        </b-row>
      </b-form>
    </b-modal>
    <b-modal
      id="mdlGerenciarTemplates"
      ref="mdlGerenciarTemplates"
      title="Templates"
      :centered="true"
      hide-footer
      size="lg"
    >
      <div class="table-numbers" style="margin-bottom: 10px">
        <table class="table table-hover">
          <thead>
            <tr class="text-center">
              <th style="width: 18%">Recurso</th>
              <th style="width: 20%">
                Criado
                <!-- <Tooltip
                  message="Templates padrão necessários para a utilização do recurso."
                /> -->
              </th>
              <th style="width: 15%">Ações</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="recurso in recursosTemplates">
              <tr v-if="recursoAtivoConta(recurso.codigo)" :key="recurso.id">
                <td class="no-wrap">
                  <i :class="recurso.icone" class="mr-2"></i>
                  <strong>{{ recurso.nome }}</strong>
                </td>
                <td></td>
                <td></td>
              </tr>
              <template v-for="template in recurso.templates">
                <tr
                  v-if="recursoAtivoConta(recurso.codigo)"
                  :key="template.name"
                >
                  <td class="no-wrap">
                    {{ template.name }}
                  </td>
                  <td class="text-center">
                    <i
                      v-if="template.existe"
                      class="fa-solid fa-check mr-2"
                      style="color: green"
                    ></i>
                    <i
                      v-else
                      class="fa-solid fa-xmark mr-2"
                      style="color: red"
                    ></i>
                  </td>
                  <td class="text-center no-wrap">
                    <b-button
                      variant="primary"
                      size="sm"
                      v-if="!template.existe"
                      @click="criarTemplate(recurso.id, template.id)"
                      >Criar template</b-button
                    >
                  </td>
                </tr></template
              ></template
            >
          </tbody>
        </table>
      </div>
    </b-modal>
    <b-modal
      id="mdlAddNumber"
      ref="mdlAddNumber"
      title="Adicionar número"
      ok-title="Adicionar"
      cancel-title="Cancelar"
      @ok.prevent="addNumber"
      :no-close-on-ok="true"
      centered
    >
      <b-form id="frmAddNumber" ref="frmAddNumber">
        <b-row class="align-items-center">
          <b-col cols="5" class="d-flex align-items-center">
            <label class="mb-0">
              Número de telefone<span style="color: red">*</span>:
            </label>
          </b-col>
          <b-col cols="7">
            <b-form-input
              v-model="newNumber.phone_number"
              placeholder="55 11 99999-9999"
              v-blur-sensitive
            ></b-form-input>
          </b-col>
        </b-row>
        <b-row class="align-items-center">
          <b-col cols="5" class="d-flex align-items-center">
            <label class="mb-0">
              ID do número<span style="color: red">*</span>:
            </label>
          </b-col>
          <b-col cols="7">
            <b-form-input
              v-model="newNumber.phone_number_id"
              placeholder="500583036465938"
              v-blur-sensitive
            ></b-form-input>
          </b-col>
        </b-row>
        <b-row class="align-items-center">
          <b-col cols="5" class="d-flex align-items-center">
            <label class="mb-0">
              ID da WABA<span style="color: red">*</span>:
            </label>
          </b-col>
          <b-col cols="7">
            <b-form-input
              v-model="newNumber.waba_id"
              placeholder="492724097251325"
              v-blur-sensitive
            ></b-form-input>
          </b-col>
        </b-row>
        <b-row class="align-items-center">
          <b-col cols="5" class="d-flex align-items-center">
            <label class="mb-0">
              Token de acesso<span style="color: red">*</span>:
            </label>
          </b-col>
          <b-col cols="7">
            <b-form-input
              v-model="newNumber.access_token"
              placeholder="EAAIsovQJkdIBOzPyKV..."
              v-blur-sensitive
            ></b-form-input>
          </b-col>
        </b-row>
        <b-row class="align-items-center">
          <b-col cols="5" class="d-flex align-items-center">
            <label class="mb-0">
              Conta:
              <Tooltip
                message="Selecione apenas se já existir caixa de entrada para esse número."
            /></label>
          </b-col>
          <b-col cols="7">
            <b-form-select
              v-model="newNumber.conta_id_inbox"
              :options="accountOptions"
              placeholder="Selecione a conta"
            ></b-form-select>
          </b-col>
        </b-row>
      </b-form>
    </b-modal>
    <div>
      <div
        style="
          display: flex;
          justify-content: space-between;
          align-items: center;
        "
      >
        <h4 style="flex-grow: 1; text-align: center">Contas conectadas</h4>
        <div style="text-align: right">
          <b-button
            v-b-tooltip.html="'Recarregar informações'"
            class="btn btn-icon btn-sm"
            @click="loadNumbersInformation()"
          >
            <i class="fa-solid fa-rotate-right" style="font-size: small"></i>
          </b-button>

          <b-button
            v-if="checkSuperAdmin"
            v-b-tooltip.html="'Adicionar número já migrado'"
            class="btn btn-icon btn-sm ml-2"
            @click="openAddNumberModal()"
          >
            <i class="fa-solid fa-plus" style="font-size: small"></i>
          </b-button>
        </div>
      </div>
      <div v-for="(account, i) in accounts" :key="i">
        <div style="align-items: center; justify-content: flex-end">
          <div style="padding-left: 4px">
            <h6
              for="filtro_ano"
              style="white-space: nowrap; margin-right: 10px"
            >
              <span v-blur-sensitive>{{ account.waba_name }}</span>
            </h6>
          </div>
        </div>
        <div class="table-numbers" style="margin-bottom: 20px">
          <table class="table table-hover" v-if="numbers.length > 0">
            <thead>
              <tr class="text-center">
                <th style="width: 18%">
                  Número de telefone
                  <Tooltip
                    message="Número de telefone cadastrado na conta do WhatsApp Business."
                  />
                </th>
                <th style="width: 20%">
                  Nome
                  <Tooltip message="Nome verificado da linha." />
                </th>
                <th style="width: 20%">
                  Conta
                  <Tooltip message="Conta a qual esse número está associado." />
                </th>
                <th style="width: 10%">
                  Status
                  <Tooltip
                    message="Indica se o número está ou não registrado. É possível registrá-lo no menu de Ações."
                  />
                </th>
                <th style="width: 18%">
                  Caixa de entrada
                  <Tooltip
                    message="Indica se já existe uma caixa de entrada no Atende. É possível criá-la no menu de Ações."
                  />
                </th>
                <th style="width: 15%">
                  Ações
                  <Tooltip
                    message="Ações disponíveis para o número de telefone."
                  />
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="numero in account.numbers"
                :key="numero.phone_number"
                class="text-center"
              >
                <td>
                  <span v-blur-sensitive>{{ numero.phone_number }}</span>
                </td>
                <td>
                  <span v-blur-sensitive>{{ numero.name }}</span>
                </td>
                <td>
                  <div
                    v-if="
                      accountOptions.find(
                        (option) => option.value === numero.conta_id
                      )
                    "
                  >
                    <span v-blur-sensitive>
                      {{
                        accountOptions.find(
                          (option) => option.value === numero.conta_id
                        ).text
                      }}
                    </span>
                    <br />
                    <span v-blur-sensitive>
                      {{
                        accountOptions.find(
                          (option) => option.value === numero.conta_id
                        ).name
                      }}
                    </span>
                  </div>
                </td>
                <td>
                  <div class="icones-container">
                    <span
                      class="label status-on label-inline mr-2"
                      v-if="numero.registered"
                      >Registrado</span
                    >
                    <span
                      v-else
                      class="label status-off label-inline mr-2"
                      style="width: 100px"
                      >Não registrado</span
                    >
                  </div>
                </td>
                <td>
                  <div class="icones-container">
                    <span
                      class="label status-on label-inline mr-2"
                      v-if="numero.inbox"
                      >Ativa</span
                    >
                    <span class="label status-off label-inline mr-2" v-else
                      >Inativa</span
                    >
                  </div>
                </td>
                <td>
                  <div class="icones-container">
                    <button
                      v-if="!numero.registered"
                      @click="register(numero, account.waba_id)"
                      class="btn btn-icon btn-light-primary btn-sm"
                      v-b-tooltip.html="'Registrar número'"
                      style="margin-right: 10px"
                      :style="{
                        cursor: numero.registered ? 'not-allowed' : 'pointer'
                      }"
                    >
                      <i
                        class="fa-solid fa-clipboard-check"
                        style="font-size: small"
                      ></i>
                    </button>

                    <button
                      v-if="!(numero.inbox && numero.registered)"
                      class="btn btn-icon btn-light-primary btn-sm"
                      v-b-tooltip.html="'Conectar número'"
                      @click="createInbox(numero, account.waba_id)"
                      style="margin-right: 10px"
                      :style="{
                        cursor: numero.inbox ? 'not-allowed' : 'pointer'
                      }"
                    >
                      <i class="flaticon2-talk" style="font-size: small"></i>
                    </button>

                    <div v-else>
                      <button
                        class="btn btn-icon btn-light-primary btn-sm"
                        v-b-tooltip.html="'Remover número'"
                        @click="selectOptions(numero, account.waba_id)"
                        style="margin-right: 10px"
                      >
                        <i class="flaticon2-trash" style="font-size: small"></i>
                      </button>
                      <button
                        class="btn btn-icon btn-light-primary btn-sm"
                        v-b-tooltip.html="'Gerenciar templates'"
                        @click="
                          exibirModalGerenciarTemplates(numero, account.waba_id)
                        "
                      >
                        <i
                          class="fa-solid fa-list-check p-0"
                          style="font-size: small"
                        ></i>
                      </button>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ApiService from "@/core/services/api.service";
import Vue from "vue";
import "vuetify/dist/vuetify.css";
import Vuetify from "vuetify";
import Swal from "sweetalert2";
import Tooltip from "./dashboard/Tooltip.vue";
import Utils from "@/core/utils/Utils";

Vue.use(Vuetify);

export default {
  components: { Tooltip },
  data() {
    return {
      accountOptions: [],
      numbers: [],
      wabaOptions: [],
      selectedNumber: null,
      selectedWaba: null,
      accounts: [],
      deleteNumberOptions: {
        excluirCaixaEntrada: false,
        desvincularNumero: false
      },
      recursosTemplates: [
        {
          id: 9,
          nome: "Agende",
          templates: [],
          icone: "flaticon2-calendar",
          codigo: "AGENDAMENTO"
        },
        {
          id: 10,
          nome: "Atende",
          templates: [],
          icone: "flaticon2-talk",
          codigo: "LIVE_CHAT"
        },
        {
          id: 12,
          nome: "Opine",
          templates: [],
          icone: "flaticon2-pie-chart-1",
          codigo: "DIZVC"
        }
      ],
      recursosConta: [],
      ultimaContaSelecionada: null,
      templatesPadrao: [],
      newNumber: {
        phone_number: "",
        phone_number_id: "",
        waba_id: "",
        access_token: "",
        conta_id_inbox: null
      },
      contasConectadas: [],
      criarCaixaEntrada: true
    };
  },
  mounted() {
    this.inicializar();
  },
  computed: {
    ...mapGetters(["recursoAtivoConta", "checkSuperAdmin"]),
    Utils() {
      return Utils;
    },
    contasDisponiveis() {
      return this.accountOptions.filter(
        (option) => !this.contasConectadas.includes(option.value)
      );
    }
  },
  methods: {
    inicializar() {
      this.getWabas();
      this.getAccounts();
      this.getTemplatesPadrao();
    },
    createInbox(numero, waba_id) {
      this.selectedNumber = numero;
      this.selectedWaba = waba_id;
      this.criarCaixaEntrada = true;
      this.contasConectadas = this.accounts
        .map((account) =>
          account.numbers
            .filter((number) => number.inbox)
            .map((number) => number.conta_id)
        )
        .flat();
      this.$bvModal.show("mdlCaixaEntrada");
    },
    async getWabas() {
      await ApiService.get("whatsapp/wabas").then((response) => {
        this.wabaOptions = response.data.data;
      });
      if (this.wabaOptions.length > 0) {
        this.loadNumbersInformation();
      }
    },
    async getAccounts() {
      await ApiService.get("administrativo/conta").then((response) => {
        this.accountOptions = [];
        this.accountOptions.push({
          value: response.data.contaPrincipal.conta_id,
          text: response.data.contaPrincipal.con_login,
          name: response.data.contaPrincipal.con_nome_identificacao
        });
        response.data.subContas.forEach((element) => {
          this.accountOptions.push({
            value: element.conta_id,
            text: element.con_login,
            name: element.con_nome_identificacao
          });
        });
      });
    },
    async getTemplatesPadrao() {
      await ApiService.get("templates-padrao").then((response) => {
        this.templatesPadrao = response.data.data;
      });
    },
    async loadNumbersInformation() {
      this.accounts = [];
      this.wabaOptions.forEach(async (waba) => {
        await ApiService.get(
          "whatsapp/phone_numbers?waba_id=" + waba.waba_id
        ).then((response) => {
          this.numbers = [];
          response.data.data.forEach((element) => {
            let number = {
              name: element.name,
              number_id: element.number_id,
              phone_number: element.phone_number,
              conta_id: element.conta_id,
              registered: element.registered,
              inbox: element.inbox,
              inbox_name: null
            };
            this.numbers.push(number);
          });
        });

        this.accounts.push({
          waba_id: waba.waba_id,
          waba_name: waba.name,
          numbers: this.numbers
        });
      });
    },
    salvarNumerosWhatsapp() {
      this.$bvModal.hide("mdlCaixaEntrada");

      ApiService.post("whatsapp/create_inbox", {
        number: this.selectedNumber,
        waba_id: this.selectedWaba,
        create_inbox: this.criarCaixaEntrada
      }).then(() => {
        Swal.fire({
          title: "SUCESSO",
          text: "Caixa de entrada criada com sucesso!",
          icon: "success",
          heightAuto: false
        }).catch(() => {
          Swal.fire({
            title: "ERRO",
            text: "Erro ao criar caixa de entrada!",
            icon: "error",
            heightAuto: false
          });
        });
      });
    },
    register(numero, waba_id) {
      ApiService.post("whatsapp/register", {
        number: numero,
        waba_id: waba_id
      })
        .then(() => {
          Swal.fire({
            title: "SUCESSO",
            text: "Número registrado com sucesso!",
            icon: "success",
            heightAuto: false
          });
          this.loadNumbersInformation();
        })
        .catch((error) => {
          Swal.fire({
            title: "ERRO",
            text: error.response.data.message,
            icon: "error",
            heightAuto: false
          });
        });
    },
    selectOptions(numero, waba_id) {
      this.selectedNumber = numero;
      this.selectedWaba = waba_id;

      this.deleteNumberOptions = {
        excluirCaixaEntrada: false,
        desvincularNumero: false
      };

      this.$bvModal.show("mdlExcluirNumero");
    },
    deleteNumber(numero, waba_id) {
      Swal.fire({
        title: "Atenção",
        text: "Deseja realmente fazer isso?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
        customClass: {
          cancelButton: "btn btn-secondary",
          confirmButton: "btn btn-danger"
        },
        buttonsStyling: false
      }).then((result) => {
        if (result.isConfirmed) {
          this.$bvModal.hide("mdlExcluirNumero");

          if (this.deleteNumberOptions.excluirCaixaEntrada) {
            ApiService.delete("whatsapp/delete_inbox", {
              number: numero,
              waba_id: waba_id
            });
          }

          if (this.deleteNumberOptions.desvincularNumero) {
            ApiService.post("whatsapp/unlink_number", {
              number: numero,
              waba_id: waba_id
            });
          }

          this.deleteNumberOptions = {
            excluirCaixaEntrada: false,
            desvincularNumero: false
          };
          this.loadNumbersInformation();
        }
      });
    },
    async exibirModalGerenciarTemplates(numero) {
      this.selectedNumber = numero;
      if (this.ultimaContaSelecionada !== numero.conta_id) {
        this.ultimaContaSelecionada = numero.conta_id;

        let templatesConta = [];

        await ApiService.get("template?conta_id=" + numero.conta_id).then(
          (response) => {
            templatesConta = response.data.data[0].templates;
          }
        );

        // Verifica se todos os templates padrão estão na lista de templates da conta
        for (let recurso of this.recursosTemplates) {
          if (
            this.verificaTemplates(
              recurso,
              this.templatesPadrao,
              templatesConta
            )
          ) {
            recurso.templates = true;
          }
        }
      }

      this.$bvModal.show("mdlGerenciarTemplates");
    },

    verificaTemplates(recurso, templatesPadrao, templatesConta) {
      // Obtem os templates padrão associados ao recursoId
      recurso.templates = templatesPadrao[recurso.id];

      if (!recurso.templates) {
        // Caso o recursoId não exista em templatesPadrao
        return null;
      }

      // Obtem os nomes dos templates da conta para facilitar a busca
      const nomesTemplatesConta = templatesConta.map(
        (template) => template.name
      );

      // Verifica se todos os templates do recurso existem nos nomes dos templates da conta
      for (let template of recurso.templates) {
        // Verifica se o template existe na lista de templates da conta
        if (
          nomesTemplatesConta.includes(template.name) ||
          nomesTemplatesConta.includes(
            recurso.nome.toLowerCase() + "_" + template.name
          )
        ) {
          template.existe = true;
        } else {
          template.existe = false;
        }
      }
    },

    criarTemplate(recursoId, templateId) {
      ApiService.post("templates-padrao", {
        conta_id: this.selectedNumber.conta_id,
        template_id: templateId
      })
        .then(() => {
          Swal.fire({
            title: "SUCESSO",
            text: "Templates criados com sucesso!",
            icon: "success",
            heightAuto: false
          });
          this.recursosTemplates
            .find((recurso) => recurso.id === recursoId)
            .templates.find(
              (template) => template.id === templateId
            ).existe = true;
        })
        .catch(() => {
          Swal.fire({
            title: "ERRO",
            text: "Erro ao criar templates!",
            icon: "error",
            heightAuto: false
          });
        });
    },
    openAddNumberModal() {
      this.$bvModal.show("mdlAddNumber");
    },
    addNumber() {
      if (
        !this.newNumber.phone_number ||
        !this.newNumber.phone_number_id ||
        !this.newNumber.waba_id ||
        !this.newNumber.access_token
      ) {
        Swal.fire({
          title: "ERRO",
          text: "Preencha todos os campos obrigatórios!",
          icon: "error",
          heightAuto: false
        });
        return;
      }

      ApiService.post("whatsapp/add_number", this.newNumber)
        .then(() => {
          Swal.fire({
            title: "SUCESSO",
            text: "Número adicionado com sucesso!",
            icon: "success",
            heightAuto: false
          });
          this.$bvModal.hide("mdlAddNumber");
          this.loadNumbersInformation();
        })
        .catch((error) => {
          Swal.fire({
            title: "ERRO",
            text: error.response.data.message,
            icon: "error",
            heightAuto: false
          });
        });
    }
  }
};
</script>

<style>
.status-on {
  background-color: rgba(97, 191, 3, 0.308);
  border-radius: 90%;
  width: 9px;
  height: 20px;
  color: green;
}
.status-off {
  background-color: rgb(214, 21, 21, 0.308);
  border-radius: 90%;
  width: 9px;
  height: 20px;
  color: red;
}

.table-numbers {
  width: 100%;
  border-top: 1.5px solid #e0e0e0;
  border-left: 1.5px solid #e0e0e0;
  border-right: 1.5px solid #e0e0e0;
  border-bottom: 1.5px solid #e0e0e0;
  border-radius: 10px;
  border-collapse: separate;
  table-layout: fixed;
}

.table-numbers td {
  vertical-align: middle;
}
</style>
